/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type DigestTimeSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type SuggestionActionSlack_org = {
    readonly id: string;
    readonly slackAccountsErrorable: {
        readonly __typename: "SlackAccountList";
        readonly list: ReadonlyArray<{
            readonly slackTeamId: string | null;
            readonly slackUserId: string | null;
            readonly teamDisplayName: string | null;
        }>;
    } | {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
        readonly statusCode: number | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly slackSettingsErrorable: {
        readonly __typename: "SlackSettingsList";
        readonly list: ReadonlyArray<{
            readonly id: string;
            readonly slackTeamId: string;
            readonly slackUserId: string;
            readonly calendarStatus: {
                readonly calendarStatusEnabled: boolean;
                readonly includeMeetingCategory: boolean;
                readonly includeMeetingTitle: boolean;
            } | null;
            readonly dailyDigestSettings: {
                readonly enabled: boolean;
                readonly timeSlot: DigestTimeSlot;
            } | null;
            readonly dndSettings: {
                readonly focusTime: boolean;
                readonly meeting: boolean;
            } | null;
            readonly notificationSettings: {
                readonly defragSummary: boolean;
            } | null;
            readonly calendarStatusEnabled: boolean;
            readonly includeMeetingCategory: boolean;
            readonly includeMeetingTitle: boolean;
        }>;
    } | {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    };
    readonly " $refType": "SuggestionActionSlack_org";
};
export type SuggestionActionSlack_org$data = SuggestionActionSlack_org;
export type SuggestionActionSlack_org$key = {
    readonly " $data"?: SuggestionActionSlack_org$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionActionSlack_org">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slackTeamId",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slackUserId",
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusCode",
        "storageKey": null
    } as any, v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarStatusEnabled",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "includeMeetingCategory",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "includeMeetingTitle",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "SuggestionActionSlack_org",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "slackAccountsErrorable",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SlackAccount",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    (v2 /*: any*/),
                                    (v3 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "teamDisplayName",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "SlackAccountList",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v4 /*: any*/),
                            (v5 /*: any*/)
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "slackSettingsErrorable",
                "plural": false,
                "selections": [
                    (v1 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "SlackSettings",
                                "kind": "LinkedField",
                                "name": "list",
                                "plural": true,
                                "selections": [
                                    (v0 /*: any*/),
                                    (v2 /*: any*/),
                                    (v3 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SlackCalendarStatusSync",
                                        "kind": "LinkedField",
                                        "name": "calendarStatus",
                                        "plural": false,
                                        "selections": [
                                            (v6 /*: any*/),
                                            (v7 /*: any*/),
                                            (v8 /*: any*/)
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SlackDailyDigestSettings",
                                        "kind": "LinkedField",
                                        "name": "dailyDigestSettings",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "enabled",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "timeSlot",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SlackDndSettings",
                                        "kind": "LinkedField",
                                        "name": "dndSettings",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "focusTime",
                                                "storageKey": null
                                            },
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "meeting",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SlackNotificationSettings",
                                        "kind": "LinkedField",
                                        "name": "notificationSettings",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "defragSummary",
                                                "storageKey": null
                                            }
                                        ],
                                        "storageKey": null
                                    },
                                    (v6 /*: any*/),
                                    (v7 /*: any*/),
                                    (v8 /*: any*/)
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "SlackSettingsList",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v5 /*: any*/),
                            (v4 /*: any*/)
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Org",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '9c137d1b17bcabd93f84b029c4db3dd9';
export default node;
